const commomPermissions = [process.env.VUE_APP_ADMINISTRADOR, process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_TOTAL]

export const arrayPermissaoAcesso = [...commomPermissions, process.env.VUE_APP_CALLCENTER_MONITOR_VISUALIZAR]

export const arrayPermissaoPausaDespausaOperador = [...commomPermissions, process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_PAUSA_DESPAUSA]

export const arrayPermissaoRemoverFila = [
  ...commomPermissions,
  process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_REMOVER_FILA,
]

export const arrayPermissaoDeslogarOperador = [
  ...commomPermissions,
  process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_DESLOGAR_OPERADOR,
]

export const arrayPermissaoOuvirOperador = [...commomPermissions, process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_OUVIR_OPERADOR]
